(function() {
  const data = document.currentScript;
  const sectionId = data.getAttribute('data-section-id');
  
  const productData = document.querySelector(`[data-product-${sectionId}]`);
  const product = productData ? JSON.parse(productData.innerHTML) : undefined;
  
  const optionsData = document.querySelector(`[data-options-${sectionId}]`);
  const options = optionsData ? JSON.parse(optionsData.innerHTML) : undefined;
  
  $( document ).ready(function() {
    init();
  });
  
  function init() {
    const colorOption = options.find((option) => isColor(option.name));
    if (!colorOption) {
      return;
    }
  
    const productVariants = product.variants;
    const colorValues = [...colorOption.values];
    const colorPosition = colorOption.position;
    const colorIndex = colorPosition - 1;
  
    const uniqueVariantImages = getUniqueVariantImages(
      productVariants,
      colorValues,
      colorIndex,
    );
  
    colorValues.forEach((colorValue, index) => {
      const colorRadioImageSelector = `img#${sectionId}-${colorPosition}-${index}`;
      const colorRadioImage = document.querySelector(colorRadioImageSelector);
      colorRadioImage.setAttribute('src', `https://${uniqueVariantImages[colorValue]}`);
    });
  }
  
  function isColor(name = '') {
    const sanitizedName = name.toLocaleLowerCase();
    return (sanitizedName === 'color' || sanitizedName === 'colors');
  }
  
  function getUniqueVariantImages(variants, colorValues, colorIndex) {
    const uniqueVariantImages = {};
  
    colorValues.forEach((colorValue) => {
      const colorValueVariantsWithImage = variants.filter(
        (variant) => variant.options[colorIndex] === colorValue && variant.featured_image !== null
      );
  
      uniqueVariantImages[colorValue] = colorValueVariantsWithImage[0].featured_image.src.replace('//', '');
    });
  
    return uniqueVariantImages;
  }
})();